import { FC, Suspense, useState } from 'react'
import Modal from 'react-responsive-modal';
import toast, { Toaster } from "react-hot-toast";
import { ErrorMessage, Formik } from "formik";
import { changeMachineLocation } from "../../models/_machine";
import { fetchQuery, useRelayEnvironment } from 'react-relay';
import Datetime from "react-datetime";
import * as _ from 'lodash';
import * as yup from "yup";
import Select from "react-select";
import clsx from 'clsx';
import { graphql } from 'babel-plugin-relay/macro';
import { useQuery } from 'react-query';
import { useMachine } from '../../providers/MachineDataProvider';

type Props = {
  currentMachineId: string;
  changeLocationModal: boolean
  handleCloseChangeLocation: () => void;
  refreshTable?: any
}
const changeLocationSchema = yup.object({
  locationId: yup.string().required("Location is required"),
  machineStatusId: yup.string().required("Machine status is required"),
})

export const getMachineById = graphql`
query ChangeLocationModal_getmachineQuery($id:String!){
  getmachine(id:$id){
    id
    uuid
    serialNumber
    name
    location {
      id
      uuid
      name
    }
  }
}
`

export const ChangeLocationModal: FC<Props> = ({
  currentMachineId,
  changeLocationModal,
  handleCloseChangeLocation,
  refreshTable
}) => {
  const environment = useRelayEnvironment();

  const refetchLocationChange = async (): Promise<void> => {
    try {
      await refetch();
      console.log("Successfully updated cache with the latest change location data.");
    } catch (error) {
      console.error("Error refetching change location data:", error);
    }
  };
  const {machineStatusDB,locationsDB,managersDB} = useMachine();
  const [loading, setLoading] = useState(false);

   const { data: machineRecord, refetch, isFetched } = useQuery(
      ["getChangeLocationMachine", currentMachineId],
      () => fetchQuery(environment, getMachineById, { id: currentMachineId ?? undefined }).toPromise(),
      {
        enabled: !!currentMachineId,
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const machines: any = machineRecord && typeof machineRecord === 'object' && 'getmachine' in machineRecord ? machineRecord.getmachine : {};
    
  return (

    <div>
      <Suspense>
        <Modal
          open={changeLocationModal && !!currentMachineId && !!machines}
          onClose={() => handleCloseChangeLocation()}
          role="modal"
          center
          classNames={{
            root: "content-wrapper",
          }}
        >
         {(machines && isFetched && currentMachineId === machines.id ) && <Formik
            enableReinitialize
            initialValues={{
              id: machines.id,
              locationId: "",
              isPilot: false,
              trialEndDate: "",
              name: machines?.name,
              machineStatusId: "",
              deployingPersonId: "",
              serialNumber: machines?.serialNumber,
            }}
            validationSchema={changeLocationSchema}
            onSubmit={async (values, { resetForm, setSubmitting }) => {
              setLoading(true);
              const updateData = {
                id: values.id,
                locationId: values.locationId,
                machineStatusId: values.machineStatusId,
                deployingPersonId: values.deployingPersonId,
                isPilot: values.isPilot,
                trialEndDate: values.trialEndDate
              };
              const result = await changeMachineLocation(
                updateData.id,
                updateData.locationId,
                values.machineStatusId,
                values.isPilot,
                values.trialEndDate,
                values.deployingPersonId
              );

              if (result?.data?.data?.changeMachineLocation) {
                refetchLocationChange();
                toast.success("Location changed successfully");
                setLoading(false)
                handleCloseChangeLocation()
                resetForm()
                if (typeof refreshTable !== 'undefined') {
                  refreshTable()
                }
              } else {
                setLoading(false)
                const messages = result?.data?.errors.map((e: any) => e.message);
                toast.error(messages.join(","));
              }
            }}

          >
            {({
              handleChange,
              handleSubmit,
              values,
              errors,
              touched,
              setFieldValue,
            }) =>
              <form
                id="kt_modal_add_lesson_form"
                className="form"
                onSubmit={handleSubmit} autoComplete="off"
                noValidate>
                <div className="modal-header p-2 pb-4 mb-4">
                  <h4 className="modal-title fs-1 pe-9">
                    Change Location - {machines.uuid}
                  </h4>
                </div>
                <div className="modal-body">

                  <div className="col-12 mt-6 pt-2">
                    <h4 className="text-gray-800">
                      Machine Name :
                      <span className="mt-2 text-muted ml-3 ms-3">
                        {machines?.name ?? ""}
                      </span>
                    </h4>
                  </div>
                  <div className="col-12 mt-6 pt-2">
                    <h4 className="text-gray-800">
                      Serial Number :
                      <span className="mt-2 text-muted ml-3 ms-3">
                        {machines.serialNumber}
                      </span>
                    </h4>
                  </div>
                  <div className="col-12 mt-6 pt-2">
                    <h4 className="text-gray-800">
                      Current Location :
                      <span className="mt-2 text-muted ml-3 ms-3">
                        {machines?.location?.name ?? ""}
                      </span>
                    </h4>
                  </div>

                  <div className="col-12 col-md-12 col-12 mt-3 pt-2">
                    <label className="form-label fs-4 required fw-bold mt-2">
                      Select New Location
                    </label>
                    <Select
                      className="react-select "
                      classNamePrefix="my-react-select"
                      name="locationId"
                      placeholder=""
                      onChange={(event: any) => {
                        setFieldValue("locationId", event.value);
                      }}
                      options={Array.from(locationsDB).map(
                        (value: any) => {
                          return {
                            value: value.id,
                            label: value.name,
                          };
                        }
                      )}
                    />
                    <div className="text-danger text-align-top-center mt-2">
                      <ErrorMessage name="locationId" />
                    </div>
                  </div>

                  {values.locationId !== '' ? <div className="col-12 col-md-12 col-12 mt-3 pt-2">
                    <label className="form-label fs-4 fw-bold d-block">
                      Is Pilot?
                    </label>
                    <div className="form-check form-switch form-check-custom form-check-solid w-100">
                      <input
                        className="form-check-input"
                        type="checkbox"

                        defaultChecked={values.isPilot === true}
                        onChange={(event) => {
                          setFieldValue("isPilot", event.target.checked)
                          setFieldValue("trialEndDate", "")
                        }
                        }
                        name="isPilot"
                      />
                    </div>
                  </div> : ''}

                  {values.isPilot ?
                    <div className="col-12 col-md-12 col-12 mt-3 pt-2">
                      <label className="form-label fs-4 required fw-bold">
                        Trial End Date
                      </label>
                      <Datetime
                        dateFormat="YYYY-MM-DD"
                        closeOnSelect
                        timeFormat={false}
                        className={clsx("date-control", {
                          "is-invalid":
                            Boolean(errors.trialEndDate) &&
                            touched.trialEndDate,
                        })}
                        value={values.trialEndDate}
                        onChange={(e: any) => {
                          const dt = e["_d"];
                          setFieldValue("trialEndDate", dt);
                        }}
                      />
                      <div className="text-danger text-align-top-center mt-2">
                        <ErrorMessage name="trialEndDate" />
                      </div>
                    </div> : ''}

                  <div className="col-12 col-md-12 col-12 mt-3 pt-2">
                    <label className="form-label required fs-4 fw-bold">
                      Machine Status
                    </label>
                    <Select
                      className="react-select"
                      classNamePrefix="my-react-select"
                      name="machineStatusId"

                      options={Array.from(machineStatusDB).map((value: any) => {
                        return {
                          value: value.id,
                          label: _.capitalize(_.lowerCase(value.name)),
                        };
                      })}
                      onChange={(e: any) => {
                        setFieldValue("machineStatusId", e.value)
                      }}
                    />
                    <div className="text-danger text-align-top-center mt-2">
                      <ErrorMessage name="machineStatusId" />
                    </div>
                  </div>

                  <div className="col-12 col-md-12 col-12 mt-3 pt-2">
                    <label className="form-label required fs-4 fw-bold">
                      Person Deploying
                    </label>
                    <Select
                      className="react-select"
                      classNamePrefix="my-react-select"
                      name="deployingPersonId"

                      options={Array.from(managersDB).map((value: any) => {
                        return {
                          value: value.id,
                          label: value.firstName,
                        };
                      })}
                      onChange={(e: any) => {
                        setFieldValue("deployingPersonId", e.value)
                      }}
                    />
                    <div className="text-danger text-align-top-center mt-2">
                      <ErrorMessage name="deployingPersonId" />
                    </div>
                  </div>


                </div>
                <div className="row">
                  <div className="col-12 col-md-12 col-12 mt-3 pt-2">
                    <button
                      type="submit"
                      className="btn btn-primary me-4 fs-4 w-100"
                    >
                      {loading && (
                        <span
                          className="indicator-progress"
                          style={{ display: "block" }}
                        >
                          Please Wait..
                          <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                        </span>
                      )}
                      {!loading && (
                        <span className="indicator-label">CHANGE LOCATION</span>
                      )}
                    </button>
                  </div>
                </div>
              </form>}
          </Formik>}
          {!isFetched &&   <div className="d-flex justify-content-center align-items-center h-100">Loading</div>}
        </Modal>
        <Toaster
          position="bottom-left"
          reverseOrder={false}
          gutter={8}
          containerClassName=""
          containerStyle={{}}
          toastOptions={{
            className: "",
            duration: 3000,
          }}
        />
      </Suspense>
    </div>
  )
}

export default ChangeLocationModal
